import moize from 'moize';
import defaultsDeep from 'lodash.defaultsdeep';
import getConfig from '../../config';
import {
    getFundDomain,
    getFundCategory,
    getFundType,
    redirectTickerToAltPage
} from '../../utils/fund-info';
import layouts from '../../layouts';
import {
    TRANSPARENCY_TYPES,
    ETF_ASSET_CLASS_TYPES
} from '../../utils/constants';

// go into fundbook util
export const getTemplateNameProperties = (fund) => [
    getFundDomain(fund),
    getFundCategory(fund)
];

const withETF = (str) => `ETF_${str}`;

// go into fundbook util
export const getTemplateName = (fundData) => {
    // LAYOUT ORDER PRECEDENCE...
    // --------------------------
    // TICKER.json
    // ST_ETF.json
    // FI_ETF.json
    // TRANSPARENT_ETF.json
    // INTERNATIONAL_STOCK.json
    // STOCK.json
    // DEFAULT.json
    // --------------------------

    if (fundData && layouts[fundData.ticker]) return fundData.ticker;

    const fundProps = getTemplateNameProperties(fundData);

    const typeLayoutNameWDomain = fundProps
        .filter((truthy) => truthy)
        .join('_');

    const isEtf = fundData.__typename === 'ExchangeTradedFund';

    if (isEtf && layouts[withETF(typeLayoutNameWDomain)]) {
        return withETF(typeLayoutNameWDomain);
    }

    const [, fundType] = fundProps;

    if (isEtf && layouts[withETF(fundType)]) {
        return withETF(fundType);
    }

    if (fundData && fundData.transparencyTypeName && isEtf) {
        if (
            fundData.transparencyTypeName === TRANSPARENCY_TYPES.SEMI &&
            layouts.ST_ETF
        ) {
            return 'ST_ETF';
        }

        if (
            fundData.assetClassName === ETF_ASSET_CLASS_TYPES.FIXED_INCOME &&
            layouts.FI_ETF
        ) {
            return 'FI_ETF';
        }

        if (
            fundData.distribution &&
            fundData.distribution.distributionFrequency === 'Monthly' &&
            layouts.EQUITY_INCOME_ETF
        ) {
            return 'EQUITY_INCOME_ETF';
        }

        if (layouts.TRANSPARENT_ETF) {
            return 'TRANSPARENT_ETF';
        }
    }

    if (layouts[typeLayoutNameWDomain]) return typeLayoutNameWDomain;

    if (layouts[fundType]) return fundType;

    return 'DEFAULT';
};

// go into fundbook util
export const fundTypeUtil = moize.deep(({ mutualFund }) => {
    if (mutualFund) {
        if (redirectTickerToAltPage(mutualFund)) {
            window.location.replace(
                `${getConfig(
                    'envDomain'
                )}/personal-investing/funds/mutual-funds/${mutualFund.ticker.toLowerCase()}.html`
            );
        }

        const { ticker } = mutualFund;

        const VDE = getFundType(mutualFund);

        const templateName = getTemplateName(mutualFund);
        const res = {
            ...VDE,
            templateName,
            fundType: templateName,
            isETF: false
        };
        global.VDE = res;
        return {
            ticker,
            ...res,
            ...layouts[templateName]
        };
    }
    return null;
});

// go into fundbook util
// need to update this so queries the etf resource and not mf
export const etfTypeUtil = moize.deep(({ exchangeTradedFund }) => {
    window.defaultsDeep = defaultsDeep;

    if (exchangeTradedFund) {
        // @note should be able to remove this when data is avail
        const etfData = defaultsDeep(
            { ...exchangeTradedFund },
            {
                advisorClass: null,
                bond: null,
                iClass: null,
                moneyMarket: null,
                name: null,
                rClass: null,
                taxFree: null,
                trpFund: null,
                trpCode: null
            }
        );

        const { ticker } = exchangeTradedFund;

        const isETF = etfData.__typename === 'ExchangeTradedFund';

        const VDE = getFundType(etfData);

        const templateName = getTemplateName(etfData);
        const res = {
            ...VDE,
            ticker,
            templateName,
            fundType: templateName,
            isETF
        };
        global.VDE = res;
        return {
            ...res,
            ...layouts[templateName]
        };
    }
    return null;
});
